export default __webpack_public_path__ + "static/media/checked_primary2.89de2db8.svg";